/**
 * @generated SignedSource<<52a35a634b2baf18c27ab84f25dfd6d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type FileListItem_file$data = {
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  };
  readonly id: string;
  readonly name: string | null;
  readonly type: FileType | null;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"FileIcon_File">;
  readonly " $fragmentType": "FileListItem_file";
};
export type FileListItem_file$key = {
  readonly " $data"?: FileListItem_file$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileListItem_file">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileListItem_file",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileIcon_File"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "f4cce8ce8a45d76950adb49685680aa9";

export default node;
